import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Trash2 } from "lucide-react";
import IconButton from "../../../components/Buttons/IconButton";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_HIGHLIGHTS_REMOVE,
  TEMPLATES_HIGHLIGHTS_TITLE,
} from "../../../i18n/keysTranslations";
import {
  listActiveHighlights,
  sortHighlightsByTextOrder,
} from "../utils/textHighlights";

const swatchSx = (color) => ({
  width: 14,
  height: 14,
  borderRadius: "4px",
  border: "1px solid #E4E4E7",
  backgroundColor: color || "transparent",
  flexShrink: 0,
});

const TextHighlightsFields = ({
  highlights = [],
  text = "",
  disabled = false,
  onChangeHighlights,
}) => {
  const { t } = useTranslationApp();
  const slots = sortHighlightsByTextOrder({
    highlights: listActiveHighlights(highlights),
    text,
  });

  if (!slots.length) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: "text.primary" }}
      >
        {t(TEMPLATES_HIGHLIGHTS_TITLE)}
      </Typography>
      {slots.map((slot) => (
        <Box
          key={slot.id}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            p: 1,
            border: "1px solid #E4E4E7",
            borderRadius: "12px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {slot.color ? <Box sx={swatchSx(slot.color)} /> : null}
            {slot.strokeColor && Number(slot.strokeWidth) > 0 ? (
              <Box sx={swatchSx(slot.strokeColor)} />
            ) : null}
            {slot.backgroundColor && Number(slot.backgroundPadding) > 0 ? (
              <Box sx={swatchSx(slot.backgroundColor)} />
            ) : null}
          </Box>
          <Typography
            variant="body2"
            sx={{
              flex: 1,
              minWidth: 0,
              fontWeight: 500,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {slot.example}
          </Typography>
          <IconButton
            tooltipText={TEMPLATES_HIGHLIGHTS_REMOVE}
            disabled={disabled}
            onClick={() =>
              onChangeHighlights(
                (Array.isArray(highlights) ? highlights : []).filter(
                  (item) => item.id !== slot.id
                )
              )
            }
          >
            <Trash2 size={16} />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default TextHighlightsFields;
